const { InspectorControls } = wp.blockEditor;
const { PanelBody, ToggleControl, TextControl } = wp.components;
import ImageControl from '../../wp-controlers/mediaUpload';

const Inspector = ({ attributes, setAttributes }) => {
  const { drop, link } = attributes;

  return (
    <InspectorControls>
      <PanelBody>
        <ImageControl
          image="image"
          attributes={attributes}
          setAttributes={setAttributes}
        />

        <ToggleControl
          label="Este item é um dropdown?"
          checked={drop}
          onChange={() => setAttributes({ drop: !drop })}
        />

        <TextControl
          label="Url Botão do Card"
          value={link}
          onChange={(link) => setAttributes({ link })}
        />
      </PanelBody>
    </InspectorControls>
  );
};

export default Inspector;
